import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[tidyChangeSquareClass]',
    standalone: false
})
export class ChangeSquareClassDirective {

  private el: ElementRef;
  private lines: number;

  @Input() replaceEnterToBlur: string;
  @Input() text: string;
  @Input() lineSize: number;

  constructor(private _el: ElementRef) {
    this.el = this._el;
  }

  removeElementsClass() {
    const elems = document.getElementsByClassName('square-selected');
    [].forEach.call(elems, (el) => {
      el.classList.remove('square-selected');
    });
  }

  @HostListener('tap', ['$event']) ontouchstart(e) {
    this.removeElementsClass();
    if (e.target.closest('.tidy-square')) {
      e.target.closest('.tidy-square').classList.add('square-selected');
    }
  }
}
